import { IElement } from "core-integration/src/store/elements/types";

export const getGroupedElements = (elements: IElement[]) => {
  const groupedElements: { front_court: IElement[]; back_court: IElement[] } = {
    front_court: [],
    back_court: [],
  };

  Object.values(elements).forEach((element: IElement) => {
    if (element.element_type === 2) {
      groupedElements.front_court.push(element);
    } else if (element.element_type === 1) {
      groupedElements.back_court.push(element);
    }
  });

  return groupedElements;
};
